export const parseGeneratedCodeFormat = (format) => {
    const elements = [];
    if (!format)
        return elements;
    let part = '';
    let inBlock = false;
    for (let i = 0; i < format.length; i++) {
        const c = format[i];
        if (!inBlock && c === '[') {
            inBlock = true;
            if (part !== '') {
                elements.push({ id: 'Text', t: part });
                part = '';
            }
        }
        else if (inBlock && c === ']') {
            inBlock = false;
            part = part.toLowerCase();
            const n = parseInt(part.replace('counter:n', '').trim());
            if (Number.isInteger(n)) {
                elements.push({ id: 'Counter', n });
            }
            part = '';
        }
        else {
            part += c;
        }
    }
    if (part !== '') {
        elements.push({ id: 'Text', t: part });
    }
    return elements;
};
const randomCounter = Math.round(Math.random() * 500);
export const generateGeneratedCodeExample = (input, counter) => {
    if (!input)
        return null;
    let elements = [];
    if (typeof input === 'string')
        elements = parseGeneratedCodeFormat(input);
    else if (Array.isArray(input))
        elements = input;
    else
        return null;
    const exampleCounter = (counter && parseInt(String(counter))) || randomCounter;
    return elements.reduce((result, el) => {
        if (el.id === 'Text')
            return result + (el.t || '');
        if (el.id === 'Counter')
            return result + String(exampleCounter).padStart(el.n || 0, '0');
        return result;
    }, '');
};
